define((require) => {
    "use strict";

    const $                              = require("jquery");
    const ChannelSetupItemViewController = require("ui/publish/channelSetup/ChannelSetupItemViewController");
    const {DateUtil}                       = require("shared/util/DateUtil");
    const EditorEvents                   = require("shared/services/EditorEvents");
    const Marionette                     = require("marionette");
    const PublishUtil                    = require("ui/publish/PublishUtil");
    const template                       = require("ui/publish/channelSetup/ChannelSetupItemView.tpl");
    const Tooltip                        = require("ui/common/Tooltip");

    const NONE_SIGN = "-";

    /**
     * Item View of a channel, showing the currently live experience, the next experience and the next
     * experience go-live date.
     *
     * @author Antonio "The Publisher" Lagrotteria & Kim "Robin" Knudsen.
     */
    return Marionette.ItemView.extend("ChannelSetupItemView", {

        className: "channel-setup-item-view",

        template,

        controller: ChannelSetupItemViewController,

        _allowedToPublish: null,

        /**
         * Used to prevent opening of multiple lightboxes when double clicking the Channel Slot.
         */
        _isLightboxOpening: false,

        templateHelpers() {
            return {
                id: this.model.identifier(),
                allowedToPublish: this._allowedToPublish
            };
        },

        initialize(options) {
            this._node = options.node; // function!
            this._allowedToPublish = options.allowedToPublish;
        },

        ui: {
            slotName: ".slot-name",
            deleteChannel: ".delete",
            liveDate: ".live-date"
        },

        events: {
            "click @ui.deleteChannel": "_deleteChannelClickHandler",
            "click": "_clickHandler"
        },

        modelEvents: {
            // Re-render when switching between experiences and groups...
            "change:experience change:group": "render",

            // Hack to re-render on "schedules" changes, as above, this is needed when switching between
            // experiences and groups...
            "change:schedules": "render",

            // Re-render channel on sync (E.g.: when clicking Refresh upon error).
            "sync:state": "render"
        },

        bindings: {
            ".slot-name": "name",

            ".live": {
                observe: ["experience", "group"],
                onGet(values) {
                    const model = values[0] || values[1];

                    return model ? model.publishableDisplayName() : NONE_SIGN;
                }
            },

            ".next": {
                observe: "schedules",
                onGet(schedules) {
                    const schedule = schedules ? schedules[0] : null;

                    if (schedule) {
                        if (schedule.takeDownCurrent) {
                            return PublishUtil.NO_EXPERIENCE_SCHEDULED.name;
                        }

                        const model = schedule.publishable;

                        // FIXME: For some odd reason, schedules can end up containing raw
                        // objects (probably an issue with computed properties on the ImprovedModel and array types?)
                        return (model && model.publishableDisplayName) ? model.publishableDisplayName() : NONE_SIGN;
                    }

                    return NONE_SIGN;
                }

            },

            ".live-date": {
                observe: "schedules",
                onGet(val) {
                    if (val && val[0] && val[0].startTime) {
                        return DateUtil.formatYYYYMMDDHHmm(val[0].startTime);
                    }

                    return NONE_SIGN;
                }
            },

            // These 4 keep the tooltip in sync...
            ".channel-tooltip .editedat": {
                observe: "editedAt",
                onGet(date) {
                    return DateUtil.formatYYYYMMDDHHmm(date || this.model.get("createdAt"));
                }
            },

            ".channel-tooltip .url": {
                observe: "url",
                onGet(val) {
                    return val || NONE_SIGN;
                }
            },

            ".channel-tooltip .selector": {
                observe: "selector",
                onGet(val) {
                    return val || NONE_SIGN;
                }
            }
        },

        _deleteChannelClickHandler(event) {
            event.stopPropagation();

            if (this._allowedToPublish && window.confirm("Are you sure you want to delete this Slot?")) {
                const projectContext = this.options.projectContext;

                this.options.parentView.trigger("handleChanges", "delete", this.model);

                const eventProperties = PublishUtil.buildEventProperties({
                    channel: this.model,
                    triggerOrigin: "DeleteChannelButton",
                    dragAndDrop: false,
                    manual: true,
                    projectId: projectContext && projectContext.project.get("id")
                });

                EditorEvents.trigger(EditorEvents.constants.DELETE_CHANNEL, eventProperties);
            }
        },

        _clickHandler({target}) {
            this._triggerEditOpened(target);
        },

        /**
         * Overridden in project class.
         * @see ProjectAttachChannelSetupItemView.
         */
        _triggerEditOpened(target) {
            if (this._isLightboxOpening) {
                return;
            }

            const className = target ? target.className : "";
            let property = "";

            switch (className) {
                case "slot-name":
                    property = "name";
                    break;

                case "live-experience":
                    property = "experience";
                    break;

                case "next-experience":
                    property = "schedules";
                    break;

                case "live-date":
                    if ($(target).text() !== "-") {
                        property = "schedules.startTime";
                    }
                    break;

                default: // No need to log here.
                    break;
            }

            this._isLightboxOpening = true;
            this.trigger("editOpened", property);
        },


        onRender() {
            this.__super();
            this.handleUnPushedChangesOnRender();
        },

        handleUnPushedChangesOnRender() {
            const version = this.model.get("version");
            const pushedVersion = this.model.get("pushedVersion");

            this.$el.toggleClass("un-pushed", this.options.hasUnPushedChannels && version > pushedVersion);
        },

        onShow() {
            Tooltip.add(this.ui.slotName, {
                width: 400,
                placement: "top",
                offset: {
                    align: "left",
                    elementWidth: 150
                },
                html: true,
                content: ":.channel-tooltip" // use this element as the tooltip template
            });

            Tooltip.add(this.ui.deleteChannel, {
                width: !this._allowedToPublish ? 180 : 100,
                placement: "top"
            });
        },

        onClose() {
            Tooltip.remove([this.ui.slotName, this.ui.deleteChannel]);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/channelSetup/ChannelSetupItemView.js